import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import css from './index.scss';
import MultilineText from '../../multiline-text/index';

const AssignedCoursesFormatter = ({ value }) => (
    <div className={css.component}>
        <MultilineText dataItems={value} />
    </div>
);

AssignedCoursesFormatter.propTypes = {
    value: PropTypes.object
};

export default AssignedCoursesFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/assigned-courses-formatter/index.js